
// eslint-disable-next-line
export default new Vuex.Store({
  modules: {
  },
  strict: false
})